import {Component, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {
    BenutzerverwaltungBenutzerZugriff,
    Funktionsbereich,
    FunktionsbereichAdminBenutzer,
    FunktionsbereichAnlegenRequest,
    FunktionsbereichBenutzerRequest,
    FunktionsbereichDetail,
    FunktionsbereichExpliziteFreigabeErforderlichFestlegenRequest,
    FunktionsbereichFreigabeRolle,
    FunktionsbereichRequest,
    FunktionsbereichUmbenennenRequest,
    Rolle,
    RolleAnlegenRequest,
    RolleDetail,
    RolleDienstplanSichtbarkeitFestlegenRequest,
    RolleExternerAnsprechpartnerFestlegenRequest,
    RolleRequest,
    RolleUmbenennenRequest,
    RolleVeranstaltungHomeSichtbarkeitFestlegenRequest
} from '../../../clients/benutzerverwaltung';
import {IonInput, LoadingController, ModalController, NavController} from '@ionic/angular';
import {select, Store} from '@ngrx/store';
import * as fromFunktionsbereicheRollenPage from './funktionsbereiche-rollen.reducer';
import {PageState} from './funktionsbereiche-rollen.reducer';
import * as fromMandantModule from '@orga-app/mandant/reducer';
import * as actionsUi from './funktionsbereiche-rollen.actions.ui';
import {
    GetFunktionsbereichAdminsAction,
    GetFunktionsbereichDetailAction,
    GetFunktionsbereicheAction,
    GetFunktionsbereichFreigabeRollenAction,
    GetFunktionsbereichRollenAction,
    GetRolleDetailAction,
    PostFunktionsbereichAdminEntfernenAction,
    PostFunktionsbereichAdminHinzufuegenAction,
    PostFunktionsbereichAnlegenAction,
    PostFunktionsbereichExpliziteFreigabeFestlegenAction,
    PostFunktionsbereichFreigabeBerechtigungRolleEntfernenAction,
    PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenAction,
    PostFunktionsbereichLoeschenAction,
    PostFunktionsbereichUmbenennenAction,
    PostRolleAnlegenAction,
    PostRolleDienstplanSichtbarkeitFestlegenAction,
    PostRolleExternerAnsprechpartnerFestlegenAction,
    PostRolleLoeschenAction,
    PostRolleUmbenennenAction
} from '../../../client-ngrx/benutzerverwaltung';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BenutzerauswahlPage} from '../benutzerauswahl/benutzerauswahl.page';
import {FunktionsbereichLoeschenPage} from '../funktionsbereich-loeschen/funktionsbereich-loeschen.page';
import {getZugriffBenutzerverwaltung} from '../../navi/navi.reducer';
import {SafeUrl} from '@angular/platform-browser';
import {GetMitteilungsVorlageDetailAction, GetRolleMitteilungOptionenAction, GetRolleMitteilungsVorlageListeAction, PostMitteilungsVorlageEmpfaengerRollenEntfernenAction, PostMitteilungsVorlageEmpfaengerRollenHinzufuegenAction, PostMitteilungsVorlageEntfernenAction, PostMitteilungsVorlageVeranstaltungsTypenEntfernenAction, PostMitteilungsVorlageVeranstaltungsTypenHinzufuegenAction, PostRolleMitteilungOptionenFestlegenAction} from '../../../client-ngrx/kommunikation';
import {RollenselektionPage} from '../rollenselektion/rollenselektion.page';
import {Datenquelle} from '../rollenselektion/rollenselektion.model';
import {Settings, SettingsProvider} from '@orga-app/settings';
import {GetFunktionsbereichAbteilungAction, GetIncidentsRolleBerechtigungAction, GetRolleAbteilungAction, GetRolleZentraleAction, PostFunktionsbereichAbteilungSetzenAction, PostRolleAbteilungSetzenAction, PostRolleZentraleSetzenAction, PostIncidentsRolleBerechtigungenSetzenAction} from '../../../client-ngrx/incidents';
import {FunktionsbereichAbteilung, IncidentsAnzeigeMandantOptions, IncidentsRolleBerechtigung, RolleAbteilung, RolleZentrale, IncidentsRolleBerechtigungenRequest, IncidentsFunktionsbereichAbteilungRequest, IncidentsRolleOptionenRequest} from '../../../clients/incidents';
import {getUserInfo, ModuleState} from '@orga-app/auth/reducer';
import {UuidService} from '@orga-app/providers/uuid.service';
import {NotificationService} from '@orga-app/providers/notification.service';
import {getTheme} from '@orga-app/settings/reducer';
import {regexValidators} from '@orga-app/providers/validator';
import {getIstDisplaysteuerungLizenzAktiv, getIstEinlasskontrolleLizenzAktiv, getIstIncidentsLizenzAktiv, getIstQSChecksLizenzAktiv} from '@orga-app/mandant/reducer';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {getIncidentsMandantOptions} from '@orga-app/mandant/reducer';
import {takeUntil, takeWhile} from 'rxjs/operators';
import {DocumentService} from '@orga-app/providers/document.service';
import {GetEinlasskontrolleRolleAction, PostEinlasskontrolleRolleBerechtigungSetzenAction} from '../../../client-ngrx/einlasskontrolle';
import {Benutzer} from '../../../clients/api';
import {GetDisplaysteuerungRolleBerechtigungAction, PostDisplaysteuerungRolleBerechtigungenSetzenAction} from '../../../client-ngrx/displaysteuerung';
import {EinlasskontrolleRolleBerechtigung, EinlasskontrolleRolleOptionenRequest} from '../../../clients/einlasskontrolle';
import {DisplaysteuerungRolleBerechtigung, DisplaysteuerungRolleBerechtigungenRequest} from '../../../clients/displaysteuerung';
import {KommunikationRolleMitteilungOptionen, KommunikationRolleMitteilungOptionenRequest, MitteilungsVorlage, MitteilungsVorlageDetail, MitteilungsVorlageRolleMultiRequest, MitteilungsVorlageTypMultiRequest} from '../../../clients/kommunikation';
import {QsChecksRolleBerechtigung, QsChecksRolleBerechtigungenRequest} from '../../../clients/qschecks';
import {GetQsChecksRolleBerechtigungAction, PostQsChecksRolleBerechtigungenSetzenAction} from '../../../client-ngrx/qschecks';
import {AktuelleVorlageEmpfaengerSetzenAction, AktuelleVorlageTypenSetzenAction, VorlageBeschreibungSetzenAction, VorlageTitelSetzenAction} from './funktionsbereiche-rollen.actions.ui';
import {DatenquelleVeranstaltungsTypen} from '../../modale/veranstaltungstyp-auswahl/veranstaltungstyp-auswahl.model';
import {VeranstaltungstypAuswahlPage} from '../../modale/veranstaltungstyp-auswahl/veranstaltungstyp-auswahl.page';
import {GetVeranstaltungBenutzerverwaltungRolleBerechtigungenAction, PostVeranstaltungenBenutzerverwaltungRolleBerechtigungenSetzenAction} from '../../../client-ngrx/veranstaltungen';
import {BvRolleBerechtigung, VeranstaltungBenutzerverwaltungRolleBerechtigungenRequest} from '../../../clients/veranstaltungen';
import {RolleLoeschenPage} from '../rolle-loeschen/rolle-loeschen.page';
import { PostRolleVeranstaltungHomeSichtbarkeitFestlegenAction } from 'src/client-ngrx/benutzerverwaltung';

@Component({
    selector: 'page-funktionsbereiche-rollen',
    templateUrl: 'funktionsbereiche-rollen.page.html',
})

export class FunktionsbereicheRollenPage implements OnInit, OnDestroy {
    @ViewChild('fehlerfallEmpfaengerInput', {static: false}) fehlerfallEmpfaengerInput: IonInput;
    @ViewChild('bereitschaftEmpfaengerInput', {static: false}) bereitschaftEmpfaengerInput: IonInput;
    @ViewChild('funktionsbereichTitelInput', {static: false}) funktionsbereichTitelInput: IonInput;
    @ViewChild('rolleTitelInput', {static: false}) rolleTitelInput: IonInput;
    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    zugriff$: Observable<BenutzerverwaltungBenutzerZugriff>;
    istIncidentsLizenzAktiv$: Observable<boolean>;
    istIncidentsLizenzAktiv: boolean;

    aiName = 'FunktionsbereicheRollenPage';
    uiFocusFehlerfallEmpfaengerInput = false;
    uiFocusBereitschaftEmpfaengerInput = false;
    uiFocusFunktionsbereichTitelInput = false;
    uiFocusRolleTitelInput = false;
    aktuelleRolle: RolleDetail = null;
    aktuellerTab = 'Kopfdaten';
    aktuellerTabKopfInnen = 'KopfAdministration';
    aktuellerTabRollenInnen = 'RollenSichtbarkeit';
    aktuellerTabRollenMitteilungenInnen = 'Empfaenger';
    funktionsbereichTitel = '';
    funktionsbereichTitelOriginal = '';
    funktionsbereichExpliziteFreigabeErforderlich = false;
    rollenTitel = '';
    rollenTitelOriginal = '';
    rolleIstExternerAnsprechpartner = false;
    rolleIstImDienstplanVerborgen = false;
    rolleVeranstaltungHomeSichtbar = false;

    rolleDarfMitteilungenSenden = false;
    rolleMitteilungAnAlle = false;
    rolleMitteilungAnAlleFB = false;
    rolleMitteilungAlleBeliebigenFB = false;
    rolleMitteilungFreigeberFB = false;
    rolleDarfMitteilungenSendenOriginal = false;
    rolleMitteilungAnAlleOriginal = false;
    rolleMitteilungAnAlleFBOriginal = false;
    rolleMitteilungAlleBeliebigenFBOriginal = false;
    rolleMitteilungFreigeberFBOriginal = false;

    rolleZentralLeitstandAktiv = false;
    rolleZentralLeitstandManager = false;
    rolleZentralLeitstandAbarbeiter = false;
    rolleZentralLeitstandLeser = false;
    rolleZentralLeitstandAktivOriginal = false;
    rolleZentralLeitstandManagerOriginal = false;
    rolleZentralLeitstandAbarbeiterOriginal = false;
    rolleZentralLeitstandLeserOriginal = false;

    rolleAbteilungsLeitstandAktiv = false;
    rolleAbteilungsLeitstandManager = false;
    rolleAbteilungsLeitstandAbarbeiter = false;
    rolleAbteilungsLeitstandLeser = false;
    rolleAbteilungsLeitstandAktivOriginal = false;
    rolleAbteilungsLeitstandManagerOriginal = false;
    rolleAbteilungsLeitstandAbarbeiterOriginal = false;
    rolleAbteilungsLeitstandLeserOriginal = false;

    funktionsbereichAbteilungsLeitstandAktiv = false;
    funktionsbereichAbteilungsLeitstandBezeichnung = '';
    funktionsbereichAbteilungsLeitstandRufnummer = '';
    funktionsbereichAbteilungsLeitstandAktivOriginal = false;
    funktionsbereichAbteilungsLeitstandBezeichnungOriginal = '';
    funktionsbereichAbteilungsLeitstandRufnummerOriginal = '';
    leitzentraleDArfDelegierenOriginal = false;

    rolleDarfVerantwortlichkeitBeiNeuanlageOriginal = false;
    rolleDarfVerantwortlichkeitBeiNeuanlage = false;
    rolleDarfDelegierenBeiNeuanlageOriginal = false;
    rolleDarfDelegierenBeiNeuanlage = false;

    rolleMitteilungsVorlagen$: Observable<Array<ListInputItem>>;
    rolleMitteilungsVorlagenLaden$: Observable<boolean>;
    rolleMitteilungsVorlagenFehler$: Observable<boolean>;
    selectedRolleMitteilungsVorlage$: Observable<MitteilungsVorlage>;

    mitteilungsVorlageDetail$: Observable<MitteilungsVorlageDetail>;
    mitteilungsVorlageDetailLaden$: Observable<boolean>;
    mitteilungsVorlageDetailFehler$: Observable<boolean>;

    vorlagenEmpfaenger$: Observable<Array<ListInputItem>>;
    vorlagenEmpfaenger: Array<ListInputItem>;
    vorlagenTypen$: Observable<Array<ListInputItem>>;
    vorlagenTypen: Array<ListInputItem>;

    selectedVorlagenEmpfaenger$: Observable<Array<string>>;
    selectedVorlagenTypen$: Observable<Array<string>>;

    leitzentraleDarfDelegieren = false;
    incidentsMandantOptions$: Observable<IncidentsAnzeigeMandantOptions>;
    einlasskontrolleLizenzAktiv$: Observable<boolean>;
    rolleEinlasskontrolleAktiv = false;
    rolleZertifikatProtokollierungAktiv = false;

    einlasskontrolleRolle$: Observable<EinlasskontrolleRolleBerechtigung>;
    einlasskontrolleRolleLaden$: Observable<boolean>;
    einlasskontrolleRolleFehler$: Observable<boolean>;

    displaysteuerungLizenzAktiv$: Observable<boolean>;
    qsChecksLizenzAktiv$: Observable<boolean>;
    rolleDisplaysteuerungAktiv = false;
    rolleQSAdminAktiv = false;
    rolleFunkprotokollAktiv = false;

    displaysteuerungRolle$: Observable<DisplaysteuerungRolleBerechtigung>;
    displaysteuerungRolleLaden$: Observable<boolean>;
    displaysteuerungRolleFehler$: Observable<boolean>;

    qsChecksRolle$: Observable<QsChecksRolleBerechtigung>;
    qsChecksRolleLaden$: Observable<boolean>;
    qsChecksRolleFehler$: Observable<boolean>;

    bvRolleBerechtigungen$: Observable<BvRolleBerechtigung>;
    bvRolleBerechtigungenLaden$: Observable<boolean>;
    bvRolleBerechtigungenFehler$: Observable<boolean>;

    neueFunktionsbereichsUuid: string = null;
    emailBenachrichtigungenBeiBereitschaftEmpfaenger: Array<string>;
    emailBenachrichtigungenBeiBereitschaftEmpfaengerOriginal: Array<string>;
    emailBenachrichtigungenBeiFehlerfallEmpfaenger: Array<string>;
    emailBenachrichtigungenBeiFehlerfallEmpfaengerOriginal: Array<string>;
    aktuelleFunktionsbereichAdminBenutzer: Array<FunktionsbereichAdminBenutzer> = [];
    aktuellerFunktionsbereichAdminBenutzer: FunktionsbereichAdminBenutzer = null;
    aktuelleFunktionsbereichFreigabeRollen: Array<FunktionsbereichFreigabeRolle> = [];
    aktuellerFunktionsbereichDetail: FunktionsbereichDetail = null;
    userInfo$: Observable<Benutzer>;
    funktionsbereichListe$: Observable<Array<ListInputItem>>;
    funktionsbereichListeUiLaden$: Observable<boolean>;
    funktionsbereichListeUiFehler$: Observable<boolean>;
    funktionsbereichListeUiFehlerObjekt$: Observable<any>;
    funktionsbereichListeUiSelektiert$: Observable<Funktionsbereich>;
    funktionsbereicheListeFilterString$: Observable<string>;
    funktionsbereichDetail$: Observable<FunktionsbereichDetail>;
    funktionsbereichDetailUiLaden$: Observable<boolean>;
    funktionsbereichDetailUiFehler$: Observable<boolean>;
    funktionsbereichDetailUiFehlerObjekt$: Observable<any>;
    funktionsbereichAdminBenutzerListe$: Observable<Array<ListInputItem>>;
    funktionsbereichAdminBenutzerListeUiLaden$: Observable<boolean>;
    funktionsbereichAdminBenutzerListeUiFehler$: Observable<boolean>;
    funktionsbereichAdminBenutzerListeUiFehlerObjekt$: Observable<any>;
    funktionsbereichAdminBenutzerListeUiSelektiert$: Observable<FunktionsbereichAdminBenutzer>;
    funktionsbereichFreigabeRolleListe$: Observable<Array<ListInputItem>>;
    funktionsbereichFreigabeRolleListeUiLaden$: Observable<boolean>;
    funktionsbereichFreigabeRolleListeUiFehler$: Observable<boolean>;
    funktionsbereichFreigabeRolleListeUiFehlerObjekt$: Observable<any>;
    funktionsbereichFreigabeRolleListeUiSelektiert$: Observable<FunktionsbereichFreigabeRolle>;
    funktionsbereichAbteilungsLeitstand$: Observable<FunktionsbereichAbteilung>;
    funktionsbereichAbteilungsLeitstandUiLaden$: Observable<boolean>;
    funktionsbereichAbteilungsLeitstandUiFehler$: Observable<boolean>;
    funktionsbereichAbteilungsLeitstandUiFehlerObjekt$: Observable<boolean>;
    rolleListe$: Observable<Array<ListInputItem>>;
    rolleListeUiLaden$: Observable<boolean>;
    rolleListeUiFehler$: Observable<boolean>;
    rolleListeUiFehlerObjekt$: Observable<any>;
    rolleListeUiSelektiert$: Observable<Rolle>;
    rolleDetail$: Observable<RolleDetail>;
    rolleDetailUiLaden$: Observable<boolean>;
    rolleDetailUiFehler$: Observable<boolean>;
    rolleDetailUiFehlerObjekt$: Observable<any>;
    rolleMitteilungOptionen$: Observable<KommunikationRolleMitteilungOptionen>;
    rolleMitteilungOptionenLaden$: Observable<boolean>;
    rolleMitteilungOptionenFehler$: Observable<boolean>;

    rolleZentralLeitstand$: Observable<RolleZentrale>;
    rolleZentralLeitstandUiLaden$: Observable<boolean>;
    rolleZentralLeitstandUiFehler$: Observable<boolean>;
    rolleZentralLeitstandUiFehlerObjekt$: Observable<any>;

    rolleAbteilungsLeitstand$: Observable<RolleAbteilung>;
    rolleAbteilungsLeitstandUiLaden$: Observable<boolean>;
    rolleAbteilungsLeitstandUiFehler$: Observable<boolean>;
    rolleAbteilungsLeitstandUiFehlerObjekt$: Observable<any>;

    rolleBerechtigung$: Observable<IncidentsRolleBerechtigung>;
    rolleBerechtigungUiLaden$: Observable<boolean>;
    rolleBerechtigungUiFehler$: Observable<boolean>;
    rolleBerechtigungUiFehlerObjekt$: Observable<any>;

    tabUiSelektiert$: Observable<string>;
    fehlerfallEmpfaengerForm: FormGroup;
    bereitschaftEmpfaengerForm: FormGroup;

    public alive = true;
    private unsubscribe$ = new Subject();

    constructor(public navCtrl: NavController,
                public modalCtrl: ModalController,
                private store: Store<PageState>,
                private storeAuth: Store<ModuleState>,
                private storeMandant: Store<fromMandantModule.MandantState>,
                private uuid: UuidService,
                public formBuilder: FormBuilder,
                public loadingCtrl: LoadingController,
                private documentService: DocumentService,
                private zone: NgZone,
                private notificationService: NotificationService,
                public settingsProvider: SettingsProvider
    ) {

        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));

        this.fehlerfallEmpfaengerForm = formBuilder.group({
            email: ['', Validators.compose([Validators.pattern(regexValidators.email), Validators.required])]
        });
        this.bereitschaftEmpfaengerForm = formBuilder.group({
            email: ['', Validators.compose([Validators.pattern(regexValidators.email), Validators.required])]
        });
    }

    ngOnInit() {
        this.zugriff$ = this.store.pipe(select(getZugriffBenutzerverwaltung));
        this.istIncidentsLizenzAktiv$ = this.storeMandant.pipe(select(getIstIncidentsLizenzAktiv));

        this.funktionsbereicheListeFilterString$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereicheListeFilterString));
        this.funktionsbereichListe$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichListe));

        this.funktionsbereichListeUiLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichListeUiLaden));
        this.funktionsbereichListeUiFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichListeUiFehler));
        this.funktionsbereichListeUiFehlerObjekt$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichListeUiFehlerObjekt));
        this.funktionsbereichListeUiSelektiert$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichListeUiSelektiert));
        this.funktionsbereichDetail$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichDetail));
        this.funktionsbereichDetailUiLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichDetailUiLaden));
        this.funktionsbereichDetailUiFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichDetailUiFehler));
        this.funktionsbereichDetailUiFehlerObjekt$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichDetailUiFehlerObjekt));
        this.funktionsbereichAdminBenutzerListe$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichAdminBenutzerListe));
        this.funktionsbereichAdminBenutzerListeUiLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichAdminBenutzerListeUiLaden));
        this.funktionsbereichAdminBenutzerListeUiFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichAdminBenutzerListeUiFehler));
        this.funktionsbereichAdminBenutzerListeUiFehlerObjekt$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichAdminBenutzerListeUiFehlerObjekt));
        this.funktionsbereichAdminBenutzerListeUiSelektiert$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichAdminBenutzerListeUiSelektiert));
        this.funktionsbereichFreigabeRolleListe$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichFreigabeRolleListe));
        this.funktionsbereichFreigabeRolleListeUiLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichFreigabeRolleListeUiLaden));
        this.funktionsbereichFreigabeRolleListeUiFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichFreigabeRolleListeUiFehler));
        this.funktionsbereichFreigabeRolleListeUiFehlerObjekt$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichFreigabeRolleListeUiFehlerObjekt));
        this.funktionsbereichFreigabeRolleListeUiSelektiert$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichFreigabeRolleListeUiSelektiert));
        this.funktionsbereichAbteilungsLeitstand$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichAbteilungsLeitstand));
        this.funktionsbereichAbteilungsLeitstandUiLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichAbteilungsLeitstandUiLaden));
        this.funktionsbereichAbteilungsLeitstandUiFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichAbteilungsLeitstandUiFehler));
        this.funktionsbereichAbteilungsLeitstandUiFehlerObjekt$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getFunktionsbereichAbteilungsLeitstandUiFehlerObjekt));
        this.rolleListe$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleListe));
        this.rolleListeUiLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleListeUiLaden));
        this.rolleListeUiFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleListeUiFehler));
        this.rolleListeUiFehlerObjekt$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleListeUiFehlerObjekt));
        this.rolleListeUiSelektiert$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleListeUiSelektiert));
        this.rolleDetail$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleDetail));
        this.rolleDetailUiLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleDetailUiLaden));
        this.rolleDetailUiFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleDetailUiFehler));
        this.rolleDetailUiFehlerObjekt$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleDetailUiFehlerObjekt));
        this.rolleMitteilungOptionen$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleMitteilungOptionen));
        this.rolleMitteilungOptionenLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleMitteilungOptionenUiLaden));
        this.rolleMitteilungOptionenFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleMitteilungOptionenUiFehler));

        this.incidentsMandantOptions$ = this.store.pipe(select(getIncidentsMandantOptions));
        this.einlasskontrolleLizenzAktiv$ = this.store.pipe(select(getIstEinlasskontrolleLizenzAktiv));

        this.displaysteuerungLizenzAktiv$ = this.store.pipe(select(getIstDisplaysteuerungLizenzAktiv));
        this.qsChecksLizenzAktiv$ = this.store.pipe(select(getIstQSChecksLizenzAktiv));

        this.rolleZentralLeitstand$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleZentralLeitstand));
        this.rolleZentralLeitstandUiLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleZentralLeitstandUiLaden));
        this.rolleZentralLeitstandUiFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleZentralLeitstandUiFehler));
        this.rolleZentralLeitstandUiFehlerObjekt$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleZentralLeitstandUiFehlerObjekt));

        this.rolleAbteilungsLeitstand$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleAbteilungsLeitstand));
        this.rolleAbteilungsLeitstandUiLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleAbteilungsLeitstandUiLaden));
        this.rolleAbteilungsLeitstandUiFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleAbteilungsLeitstandUiFehler));
        this.rolleAbteilungsLeitstandUiFehlerObjekt$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleAbteilungsLeitstandUiFehlerObjekt));

        this.rolleBerechtigung$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleBerechtigung));
        this.rolleBerechtigungUiLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleBerechtigungUiLaden));
        this.rolleBerechtigungUiFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleBerechtigungUiFehler));
        this.rolleBerechtigungUiFehlerObjekt$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleBerechtigungUiFehlerObjekt));

        this.rolleMitteilungsVorlagen$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleMitteilungsVorlagen));
        this.rolleMitteilungsVorlagenLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleMitteilungsVorlagenLaden));
        this.rolleMitteilungsVorlagenFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleMitteilungsVorlagenFehler));
        this.selectedRolleMitteilungsVorlage$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getSelectedRolleMitteilungsVorlage));

        this.mitteilungsVorlageDetail$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getMitteilungsVorlageDetail));
        this.mitteilungsVorlageDetailLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getMitteilungsVorlageDetailLaden));
        this.mitteilungsVorlageDetailFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getMitteilungsVorlageDetailFehler));

        this.vorlagenEmpfaenger$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getVorlagenEmfpaenger));
        this.vorlagenTypen$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getVorlagenTypen));

        this.selectedVorlagenEmpfaenger$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getSelectedVorlageEmpfaenger));
        this.selectedVorlagenTypen$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getSelectedVorlageTypen));

        this.einlasskontrolleRolle$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleEinlasskontrolle));
        this.einlasskontrolleRolleLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleEinlasskontrolleLaden));
        this.einlasskontrolleRolleFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleEinlasskontrolleFehler));

        this.displaysteuerungRolle$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleDisplaysteuerung));
        this.displaysteuerungRolleLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleDisplaysteuerungLaden));
        this.displaysteuerungRolleFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleDisplaysteuerungFehler));

        this.qsChecksRolle$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleQsChecks));
        this.qsChecksRolleLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleQsChecksLaden));
        this.qsChecksRolleFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getRolleQsChecksFehler));

        this.bvRolleBerechtigungen$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getBVRolleBerechtigungen));
        this.bvRolleBerechtigungenLaden$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getBVRolleBerechtigungenLaden));
        this.bvRolleBerechtigungenFehler$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getBVRolleBerechtigungenFehler));

        this.tabUiSelektiert$ = this.store.pipe(select(fromFunktionsbereicheRollenPage.getTabUiSelektiert));

        this.userInfo$ = this.storeAuth.pipe(select(getUserInfo));


        this.tabUiSelektiert$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: string) => {
            this.zone.run(() => {
                this.aktuellerTab = x;
            });
        });

        this.funktionsbereichDetail$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: FunktionsbereichDetail) => {
            // if (x != null && x.titel != null) {
            if (x != null) {
                this.aktuellerFunktionsbereichDetail = x;
                this.funktionsbereichTitel = x.titel;
                this.funktionsbereichTitelOriginal = x.titel;
                this.funktionsbereichExpliziteFreigabeErforderlich = x.explizite_freigabe_erforderlich;
                this.emailBenachrichtigungenBeiBereitschaftEmpfaenger = (x.email_benachrichtigungen_bei_bereitschaft_empfaenger === '' || x.email_benachrichtigungen_bei_bereitschaft_empfaenger == null) ? [] : x.email_benachrichtigungen_bei_bereitschaft_empfaenger.split(';');
                this.emailBenachrichtigungenBeiBereitschaftEmpfaengerOriginal = (x.email_benachrichtigungen_bei_bereitschaft_empfaenger === '' || x.email_benachrichtigungen_bei_bereitschaft_empfaenger == null) ? [] : x.email_benachrichtigungen_bei_bereitschaft_empfaenger.split(';');
                this.emailBenachrichtigungenBeiFehlerfallEmpfaenger = (x.email_benachrichtigungen_bei_fehlerfall_empfaenger === '' || x.email_benachrichtigungen_bei_fehlerfall_empfaenger == null) ? [] : x.email_benachrichtigungen_bei_fehlerfall_empfaenger.split(';');
                this.emailBenachrichtigungenBeiFehlerfallEmpfaengerOriginal = (x.email_benachrichtigungen_bei_fehlerfall_empfaenger === '' || x.email_benachrichtigungen_bei_fehlerfall_empfaenger == null) ? [] : x.email_benachrichtigungen_bei_fehlerfall_empfaenger.split(';');

                if (this.uiFocusFunktionsbereichTitelInput) {
                    this.uiFocusFunktionsbereichTitelInput = false;
                    setTimeout(() => {
                        if (this.funktionsbereichTitelInput) {
                            this.funktionsbereichTitelInput.setFocus();
                        }

                    }, 10);
                }

                if (this.uiFocusFehlerfallEmpfaengerInput) {
                    this.uiFocusFehlerfallEmpfaengerInput = false;
                    setTimeout(() => {
                        if (this.fehlerfallEmpfaengerInput) {
                            this.fehlerfallEmpfaengerInput.setFocus();
                        }
                    }, 10);
                }

                if (this.uiFocusBereitschaftEmpfaengerInput) {
                    this.uiFocusBereitschaftEmpfaengerInput = false;
                    setTimeout(() => {
                        if (this.bereitschaftEmpfaengerInput) {
                            this.bereitschaftEmpfaengerInput.setFocus();
                        }
                    }, 10);
                }

                if (this.uiFocusRolleTitelInput) {
                    this.uiFocusRolleTitelInput = false;
                    setTimeout(() => {
                        if (this.rolleTitelInput) {
                            this.rolleTitelInput.setFocus();
                        }
                    }, 10);
                }
            } else {
                this.aktuellerFunktionsbereichDetail = null;
                this.funktionsbereichExpliziteFreigabeErforderlich = false;
                this.funktionsbereichTitel = '';
                this.funktionsbereichTitelOriginal = '';
                this.emailBenachrichtigungenBeiBereitschaftEmpfaenger = [];
                this.emailBenachrichtigungenBeiBereitschaftEmpfaengerOriginal = [];
                this.emailBenachrichtigungenBeiFehlerfallEmpfaenger = [];
                this.emailBenachrichtigungenBeiFehlerfallEmpfaengerOriginal = [];
            }

        });

        this.rolleDetail$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: RolleDetail) => {
            if (x != null && x.titel != null) {
                this.rollenTitel = x.titel;
                this.rollenTitelOriginal = x.titel;
                this.zone.run(() => {
                    return this.rolleIstExternerAnsprechpartner = x.ist_externer_ansprechpartner;
                });
                this.zone.run(() => this.rolleIstImDienstplanVerborgen = x.ist_im_dienstplan_verborgen);
                this.zone.run(() => this.rolleVeranstaltungHomeSichtbar = x.ist_im_veranstaltung_home_sichtbar);

                if (this.uiFocusRolleTitelInput) {
                    this.uiFocusRolleTitelInput = false;

                    setTimeout(() => {
                        if (this.rolleTitelInput) {
                            this.rolleTitelInput.setFocus();
                        }
                    }, 10);
                }
            } else {
                this.rollenTitel = '';
                this.rollenTitelOriginal = '';
                this.aktuelleRolle = null;
                this.zone.run(() => {
                    return this.rolleIstExternerAnsprechpartner = false;
                });
                this.zone.run(() => this.rolleIstImDienstplanVerborgen = false);
                this.zone.run(() => this.rolleVeranstaltungHomeSichtbar = false);
            }
        });

        this.rolleMitteilungOptionen$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: KommunikationRolleMitteilungOptionen) => {
            if (x != null) {
                this.rolleDarfMitteilungenSenden = x.darf_mitteilungen_senden;
                this.rolleMitteilungAnAlle = x.senden_an_alle;
                this.rolleMitteilungAnAlleFB = x.senden_an_eigenen_funktionsbereich;
                this.rolleMitteilungAlleBeliebigenFB = x.senden_an_beliebigen_funktionsbereich;
                this.rolleMitteilungFreigeberFB = x.senden_an_funktionsbereich_freigeber;

                this.rolleDarfMitteilungenSendenOriginal = this.rolleDarfMitteilungenSenden;
                this.rolleMitteilungAnAlleOriginal = this.rolleMitteilungAnAlle;
                this.rolleMitteilungAnAlleFBOriginal = this.rolleMitteilungAnAlleFB;
                this.rolleMitteilungAlleBeliebigenFBOriginal = this.rolleMitteilungAlleBeliebigenFB;
                this.rolleMitteilungFreigeberFBOriginal = this.rolleMitteilungFreigeberFB;

            } else {
                this.rolleDarfMitteilungenSenden = false;
                this.rolleMitteilungAnAlle = false;
                this.rolleMitteilungAnAlleFB = false;
                this.rolleMitteilungAlleBeliebigenFB = false;
                this.rolleMitteilungFreigeberFB = false;
            }
        });

        this.funktionsbereichAdminBenutzerListe$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: Array<ListInputItem>) => {
            if (x != null) {
                this.aktuelleFunktionsbereichAdminBenutzer = x.map(y => y.item);
            }
        });

        this.funktionsbereichFreigabeRolleListe$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: Array<ListInputItem>) => {
            if (x != null) {
                this.aktuelleFunktionsbereichFreigabeRollen = x.map(y => y.item);
            }
        });

        this.funktionsbereichAbteilungsLeitstand$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: FunktionsbereichAbteilung) => {
            if (x != null) {
                this.funktionsbereichAbteilungsLeitstandAktiv = x.ist_aktiv;
                this.funktionsbereichAbteilungsLeitstandBezeichnung = x.bezeichnung;
                this.funktionsbereichAbteilungsLeitstandRufnummer = x.rufnummer;
                this.leitzentraleDarfDelegieren = x.zentrale_darf_delegieren;

                this.funktionsbereichAbteilungsLeitstandAktivOriginal = this.funktionsbereichAbteilungsLeitstandAktiv;
                this.funktionsbereichAbteilungsLeitstandBezeichnungOriginal = this.funktionsbereichAbteilungsLeitstandBezeichnung;
                this.funktionsbereichAbteilungsLeitstandRufnummerOriginal = this.funktionsbereichAbteilungsLeitstandRufnummer;
                this.leitzentraleDArfDelegierenOriginal = this.leitzentraleDarfDelegieren;

            } else {
                this.funktionsbereichAbteilungsLeitstandAktiv = false;
                this.funktionsbereichAbteilungsLeitstandBezeichnung = '';
                this.funktionsbereichAbteilungsLeitstandRufnummer = '';
                this.leitzentraleDarfDelegieren = false;
            }
        });

        this.rolleZentralLeitstand$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: RolleZentrale) => {
            if (x != null) {
                this.rolleZentralLeitstandAktiv = x.ist_aktiv;
                this.rolleZentralLeitstandManager = x.ist_manager;
                this.rolleZentralLeitstandAbarbeiter = x.ist_abarbeiter;
                this.rolleZentralLeitstandLeser = x.ist_leser;

                this.rolleZentralLeitstandAktivOriginal = this.rolleZentralLeitstandAktiv;
                this.rolleZentralLeitstandManagerOriginal = this.rolleZentralLeitstandManager;
                this.rolleZentralLeitstandAbarbeiterOriginal = this.rolleZentralLeitstandAbarbeiter;
                this.rolleZentralLeitstandLeserOriginal = this.rolleZentralLeitstandLeser;

            } else {
                this.rolleZentralLeitstandAktiv = false;
                this.rolleZentralLeitstandManager = false;
                this.rolleZentralLeitstandAbarbeiter = false;
                this.rolleZentralLeitstandLeser = false;
            }
        });

        this.rolleAbteilungsLeitstand$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: RolleAbteilung) => {
            if (x != null) {
                this.rolleAbteilungsLeitstandAktiv = x.ist_aktiv;
                this.rolleAbteilungsLeitstandManager = x.ist_manager;
                this.rolleAbteilungsLeitstandAbarbeiter = x.ist_abarbeiter;
                this.rolleAbteilungsLeitstandLeser = x.ist_leser;

                this.rolleAbteilungsLeitstandAktivOriginal = this.rolleAbteilungsLeitstandAktiv;
                this.rolleAbteilungsLeitstandManagerOriginal = this.rolleAbteilungsLeitstandManager;
                this.rolleAbteilungsLeitstandAbarbeiterOriginal = this.rolleAbteilungsLeitstandAbarbeiter;
                this.rolleAbteilungsLeitstandLeserOriginal = this.rolleAbteilungsLeitstandLeser;

            } else {
                this.rolleAbteilungsLeitstandAktiv = false;
                this.rolleAbteilungsLeitstandManager = false;
                this.rolleAbteilungsLeitstandAbarbeiter = false;
                this.rolleAbteilungsLeitstandLeser = false;
            }
        });

        this.rolleBerechtigung$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: IncidentsRolleBerechtigung) => {
            if (x != null) {
                this.rolleDarfVerantwortlichkeitBeiNeuanlage = x.darf_verantwortung_bei_anlegen;
                this.rolleDarfDelegierenBeiNeuanlage = x.darf_delegation_bei_anlegen;

                this.rolleDarfVerantwortlichkeitBeiNeuanlageOriginal = this.rolleDarfVerantwortlichkeitBeiNeuanlage;
                this.rolleDarfDelegierenBeiNeuanlageOriginal = this.rolleDarfDelegierenBeiNeuanlage;

            } else {
                this.rolleDarfVerantwortlichkeitBeiNeuanlage = false;
                this.rolleDarfDelegierenBeiNeuanlage = false;
            }
        });

        this.einlasskontrolleRolle$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: EinlasskontrolleRolleBerechtigung) => {
            if (x != null) {
                this.rolleEinlasskontrolleAktiv = x.ist_aktiv;
                this.rolleZertifikatProtokollierungAktiv = x.ist_protokollierung_aktiv;
            } else {
                this.rolleEinlasskontrolleAktiv = false;
                this.rolleZertifikatProtokollierungAktiv = false;
            }
        });

        this.istIncidentsLizenzAktiv$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: boolean) => this.istIncidentsLizenzAktiv = x);

        this.displaysteuerungRolle$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: DisplaysteuerungRolleBerechtigung) => {
            if (x != null) {
                this.rolleDisplaysteuerungAktiv = x.darf_verwalten;
            } else {
                this.rolleDisplaysteuerungAktiv = false;
            }
        });

        this.qsChecksRolle$.pipe(takeUntil(this.unsubscribe$)).subscribe( (x: QsChecksRolleBerechtigung) => {
            if (x !== null) {
                this.rolleQSAdminAktiv = x.ist_qs_admin;
            } else {
                this.rolleQSAdminAktiv = false;
            }
        });

        this.bvRolleBerechtigungen$.pipe(takeUntil(this.unsubscribe$)).subscribe((x: BvRolleBerechtigung) => {
            if (x !== null) {
                this.rolleFunkprotokollAktiv = x.darf_funkprotokoll;
            } else {
                this.rolleFunkprotokollAktiv = false;
            }
        });

        this.vorlagenEmpfaenger$.pipe(takeUntil(this.unsubscribe$)).subscribe((x) => this.vorlagenEmpfaenger = x);
        this.vorlagenTypen$.pipe(takeUntil(this.unsubscribe$)).subscribe((x) => this.vorlagenTypen = x);
    }


    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        this.unsubscribe$ = new Subject<void>();
        this.store.dispatch(new actionsUi.PageStateResetAction());
        await this.funktionsbereicheLaden();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    // Funktionsbereiche
    async funktionsbereicheLaden() {
        this.store.dispatch(new GetFunktionsbereicheAction());
    }

    async neuenFunktionsbereich() {
        this.funktionsbereichTitel = '';
        this.funktionsbereichTitelOriginal = '';
        this.aktuellerFunktionsbereichDetail = null;
        this.aktuellerTab = 'Kopfdaten';
        this.aktuellerTabKopfInnen = 'KopfAdministration';
        this.aktuellerTabRollenInnen = 'RollenSichtbarkeit';
        this.aktuellerTabRollenMitteilungenInnen = 'Empfaenger';
        this.store.dispatch(new actionsUi.NeuenFunktionsbereichAction(<FunktionsbereichDetail>{}));
        setTimeout(function () {
            if (this.funktionsbereichTitelInput) {
                this.funktionsbereichTitelInput.setFocus();
            }
        }.bind(this), 500);
    }

    async neuenFunktionsbereichAbbrechen() {
        this.funktionsbereichTitel = '';
        this.funktionsbereichTitelOriginal = '';
        this.aktuellerFunktionsbereichDetail = null;
        this.store.dispatch(new actionsUi.NeuenFunktionsbereichAbbrechenAction());
    }


    async funktionsbereichSpeichern() {
        if (this.funktionsbereichTitel !== this.funktionsbereichTitelOriginal) {
            this.funktionsbereichTitelSpeichernOderUmbenennen();
        }
        this.uiFocusFunktionsbereichTitelInput = true;
    }

    async funktionsbereichTitelSpeichernOderUmbenennen() {
        if (this.aktuellerFunktionsbereichDetail.funktionsbereich_id === undefined) {
            // Funktionsbereich anlegen
            const uuid = this.uuid.generateUUID();
            const request = <FunktionsbereichAnlegenRequest>{
                titel: this.funktionsbereichTitel,
                explizite_freigabe_erforderlich: false,
                funktionsbereich_id: uuid,
                zeitpunkt_utc: new Date(Date.now())
            };
            this.neueFunktionsbereichsUuid = uuid;
            this.store.dispatch(new actionsUi.NeuenFunktionsbereichAction(<FunktionsbereichDetail>{funktionsbereich_id: uuid, titel: this.funktionsbereichTitel, explizite_freigabe_erforderlich: false}));
            this.store.dispatch(new PostFunktionsbereichAnlegenAction(request));
        } else {
            // Funktionsbereich umbennen
            const request = <FunktionsbereichUmbenennenRequest>{
                funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
                neuer_titel: this.funktionsbereichTitel,
                zeitpunkt_utc: new Date(Date.now())
            };
            this.store.dispatch(new PostFunktionsbereichUmbenennenAction(request));
        }
    }

    async funktionsbereichLaden(item: Funktionsbereich) {
        this.store.dispatch(new actionsUi.AktuellenFunktionsbereichSetzenAction(item));
        this.store.dispatch(new GetFunktionsbereichDetailAction(item.funktionsbereich_id));
        this.rollenLaden(item);
        this.funktionsbereichAdminsLaden(item);
        this.funktionsbereichFreigabeRollenLaden(item);
        if (this.istIncidentsLizenzAktiv) {
            this.funktionsbereichAbteilungsLeitstandLaden(item);
        }
        this.uiFocusFunktionsbereichTitelInput = true;
    }

    async funktionsbereichEntfernen(item: Funktionsbereich) {
        // TODO V3 ORGArena: funktionsbereich löschen modal einfügen
        const param = {titel: item.titel};
        const modal = await this.modalCtrl.create({component: FunktionsbereichLoeschenPage, componentProps: param});
        modal.onDidDismiss().then(data => {
            if (data !== undefined && data.data !== undefined) {
                const request = <FunktionsbereichRequest>{
                    funktionsbereich_id: item.funktionsbereich_id,
                    zeitpunkt_utc: new Date(Date.now())
                };

                this.store.dispatch(new PostFunktionsbereichLoeschenAction(request));
            }
        });

        await modal.present();
    }


    // Rollen
    async rollenLaden(item: Funktionsbereich) {
        if (item != null && item.funktionsbereich_id != null && item.funktionsbereich_id !== '') {
            this.store.dispatch(new GetFunktionsbereichRollenAction(item.funktionsbereich_id));
        } else {
            console.log('Keine Funktionsbereich übergeben.');
        }
    }

    async rolleLaden(item: Rolle) {
        if (item != null && item.rolle_id != null) {
            this.store.dispatch(new actionsUi.AktuelleRolleSetzenAction(item));
            this.aktuelleRolle = item;
            this.rollenTitel = item.titel;
            this.rollenTitelOriginal = item.titel;
            this.uiFocusRolleTitelInput = true;
            this.store.dispatch(new GetRolleDetailAction(item.rolle_id));
            this.store.dispatch(new GetRolleMitteilungOptionenAction(item.rolle_id));
            if (this.istIncidentsLizenzAktiv) {
                this.store.dispatch(new GetRolleZentraleAction(item.rolle_id));
                this.store.dispatch(new GetRolleAbteilungAction(item.rolle_id));
                this.store.dispatch(new GetIncidentsRolleBerechtigungAction(item.rolle_id));
            }
            if (this.einlasskontrolleLizenzAktiv$) {
                this.store.dispatch(new GetEinlasskontrolleRolleAction(item.rolle_id));
            }
            if (this.displaysteuerungLizenzAktiv$) {
                this.store.dispatch(new GetDisplaysteuerungRolleBerechtigungAction(item.rolle_id));
            }
            if (this.qsChecksLizenzAktiv$) {
                this.store.dispatch(new GetQsChecksRolleBerechtigungAction(item.rolle_id));
            }
            this.store.dispatch(new GetRolleMitteilungsVorlageListeAction(item.rolle_id));
            this.store.dispatch(new GetVeranstaltungBenutzerverwaltungRolleBerechtigungenAction(item.rolle_id));
        } else {
            console.log('Keine Rolle übergeben.');
        }
    }

    async neueRolle() {
        this.rollenTitel = '';
        this.rollenTitelOriginal = '';
        this.aktuelleRolle = null;
        this.rolleIstExternerAnsprechpartner = false;
        this.rolleIstImDienstplanVerborgen = false;
        this.rolleVeranstaltungHomeSichtbar = false;
        this.uiFocusRolleTitelInput = true;
        this.store.dispatch(new actionsUi.AktuelleRolleSetzenAction(null));
        this.store.dispatch(new actionsUi.NeueRolleAction());
        setTimeout(() => {
            if (this.rolleTitelInput) {
                this.rolleTitelInput.setFocus();
            }
        }, 1000);
    }

    async neueRolleAbbrechen() {
        this.rollenTitel = '';
        this.rollenTitelOriginal = '';
        this.aktuelleRolle = null;
        this.store.dispatch(new actionsUi.NeueRolleAbbrechenAction());
        this.store.dispatch(new actionsUi.AktuelleRolleSetzenAction(null));
    }


    async rolleSpeichern() {
        if (this.aktuelleRolle == null) {
            // Rolle anlegen
            const uuid = this.uuid.generateUUID();
            const rolleAnlegenRequest = <RolleAnlegenRequest>{
                titel: this.rollenTitel,
                funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
                zeitpunkt_utc: new Date(Date.now()),
                rolle_id: uuid
            };
            this.store.dispatch(new PostRolleAnlegenAction(rolleAnlegenRequest));
            this.neueRolle();
        } else {
            const request = <RolleUmbenennenRequest>{
                funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
                neuer_titel: this.rollenTitel,
                zeitpunkt_utc: new Date(Date.now()),
                rolle_id: this.aktuelleRolle.rolle_id
            };
            this.store.dispatch(new PostRolleUmbenennenAction(request));
            this.rollenTitelOriginal = this.rollenTitel;
        }
        this.uiFocusRolleTitelInput = true;
    }

    async rolleEntfernen(item) {
        if (this.aktuellerFunktionsbereichDetail !== null && this.aktuellerFunktionsbereichDetail.funktionsbereich_id !== null && item != null
            && item.rolle_id != null) {
            const param = {titel: item.titel};
            const modal = await this.modalCtrl.create({component: RolleLoeschenPage, componentProps: param});
            modal.onDidDismiss().then(result => {
                if (result != null && result.data) {
                    const request = <RolleRequest>{
                        funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
                        rolle_id: item.rolle_id,
                        zeitpunkt_utc: new Date(Date.now())
                    };
                    this.store.dispatch(new PostRolleLoeschenAction(request));
                    this.aktuelleRolle = null;
                    this.rollenTitel = '';
                    this.rollenTitelOriginal = '';
                    this.store.dispatch(new actionsUi.AktuelleRolleSetzenAction(null));
                    this.store.dispatch(new actionsUi.NeueRolleAbbrechenAction());
                }
            });

            await modal.present();
        }
    }

    async externerAnsprechpartner() {
        const request = <RolleExternerAnsprechpartnerFestlegenRequest>{
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            rolle_id: this.aktuelleRolle.rolle_id,
            zeitpunkt_utc: new Date(Date.now()),
            ist_externer_ansprechpartner: !this.rolleIstExternerAnsprechpartner
        };
        this.store.dispatch(new PostRolleExternerAnsprechpartnerFestlegenAction(request));
    }

    async rolleVerbergen() {
        const request = <RolleDienstplanSichtbarkeitFestlegenRequest>{
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            rolle_id: this.aktuelleRolle.rolle_id,
            zeitpunkt_utc: new Date(Date.now()),
            ist_verborgen: !this.rolleIstImDienstplanVerborgen
        };
        this.store.dispatch(new PostRolleDienstplanSichtbarkeitFestlegenAction(request));
    }

    async veranstaltungHomeSichtbar() {
        const request = <RolleVeranstaltungHomeSichtbarkeitFestlegenRequest>{
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            rolle_id: this.aktuelleRolle.rolle_id,
            zeitpunkt_utc: new Date(Date.now()),
            ist_sichtbar: !this.rolleVeranstaltungHomeSichtbar
        };
        this.store.dispatch(new PostRolleVeranstaltungHomeSichtbarkeitFestlegenAction(request));
    }

    // FunktionsbereichsAdmins
    async funktionsbereichAdminsLaden(item: Funktionsbereich) {
        this.store.dispatch(new GetFunktionsbereichAdminsAction(item.funktionsbereich_id));
    }

    async funktionsbereichAbteilungsLeitstandLaden(item: Funktionsbereich) {
        this.store.dispatch(new GetFunktionsbereichAbteilungAction(item.funktionsbereich_id));
    }

    async aktuellenFunktionsbereichAdminSetzen(item: FunktionsbereichAdminBenutzer) {
        this.aktuellerFunktionsbereichAdminBenutzer = item;
        this.store.dispatch(new actionsUi.AktuellenFunktionsbereichsAdminSetzenAction(item));
    }

    async funktionsbereichAdminEntfernen(item: FunktionsbereichAdminBenutzer) {
        const request = <FunktionsbereichBenutzerRequest>{
            funktionsbereich_id: item.funktionsbereich_id,
            benutzer_id: item.benutzer_id,
            zeitpunkt_utc: new Date(Date.now())
        };
        this.store.dispatch(new PostFunktionsbereichAdminEntfernenAction(request));
    }

    async funktionsbereichAdminAuswahl() {
        const params = {
            titel: this.aktuellerFunktionsbereichDetail.titel,
            aktuell: this.aktuelleFunktionsbereichAdminBenutzer.map(item => item.benutzer_id)
        };
        const modal = await this.modalCtrl.create({component: BenutzerauswahlPage, componentProps: params});
        modal.onDidDismiss().then((data: any) => {
            if (data.data !== undefined && data.data.hinzugefuegte !== undefined) {
                let i = 0;
                data.data.hinzugefuegte.forEach(item => {
                        // ADMIN hinzufügen
                        const request = <FunktionsbereichBenutzerRequest>{
                            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
                            benutzer_id: item,
                            zeitpunkt_utc: new Date(Date.now())
                        };
                        setTimeout(() => {
                            this.store.dispatch(new PostFunktionsbereichAdminHinzufuegenAction(request));
                        }, 500 * i);
                        i++;
                    }
                );
                i = 0;
                data.data.entfernte.forEach(item => {
                    // ADMIN entfernen
                    const request = <FunktionsbereichBenutzerRequest>{
                        funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
                        benutzer_id: item.benutzer_id,
                        zeitpunkt_utc: new Date(Date.now())
                    };

                    setTimeout(() => {
                        this.store.dispatch(new PostFunktionsbereichAdminEntfernenAction(request));
                    }, 500 * i);
                    i++;
                });
            }
        });

        await modal.present();
    }

    trackByBenutzer(index: number, benutzer: FunktionsbereichAdminBenutzer) {
        return benutzer.benutzer_id;
    }

    // FunktionsbereichsAdmins
    async funktionsbereichFreigabeRollenLaden(item: Funktionsbereich) {
        this.store.dispatch(new GetFunktionsbereichFreigabeRollenAction(item.funktionsbereich_id));
    }

    async aktuellenFunktionsbereichFreigabeRolleSetzen(item: FunktionsbereichFreigabeRolle) {
        this.aktuellerFunktionsbereichAdminBenutzer = item;
        this.store.dispatch(new actionsUi.AktuellenFunktionsbereichsFreigabeRolleSetzenAction(item));
    }

    async funktionsbereichFreigabeRollenEntfernen(item: FunktionsbereichFreigabeRolle) {
        // ADMIN entfernen
        const request = <RolleRequest>{
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            rolle_id: item.rolle_id,
            zeitpunkt_utc: new Date(Date.now())
        };
        this.store.dispatch(new PostFunktionsbereichFreigabeBerechtigungRolleEntfernenAction(request));
    }

    async funktionsbereichFreigabeRollenAuswahl() {
        const params = {
            titel: this.funktionsbereichTitel,
            nichtAnzuzeigendeRollenIds: this.aktuelleFunktionsbereichFreigabeRollen.map(x => x.rolle_id),
            funktionsbereich: this.aktuellerFunktionsbereichDetail,
            checkliste: null,
            untertitel: 'Freigabe-Rollen auswählen',
            alleAnzeigenAuswahlAnzeigen: true,
            alleAnzeigen: false,
            datenquelle: Datenquelle.Benutzerverwaltung
        };

        const modal = await this.modalCtrl.create({component: RollenselektionPage, componentProps: params});
        modal.onDidDismiss().then((data: any) => {
            if (data.data !== undefined && data.data.ausgewaehlteRollen !== undefined) {
                let i = 0;
                data.data.ausgewaehlteRollen.forEach(rolleId => {
                    const request = <RolleRequest>{
                        funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
                        rolle_id: rolleId,
                        zeitpunkt_utc: new Date(Date.now())
                    };
                    setTimeout(() => {
                        this.store.dispatch(new PostFunktionsbereichFreigabeBerechtigungRolleHinzufuegenAction(request));
                    }, 500 * i);
                    i++;
                });
            }
        });

        await modal.present();
    }


    async changeExpliziteFreigabe($event) {
        const request = <FunktionsbereichExpliziteFreigabeErforderlichFestlegenRequest>{
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            explizite_freigabe_berechtigung_erforderlich: $event.detail.checked,
            zeitpunkt_utc: new Date(Date.now())
        };
        this.store.dispatch(new PostFunktionsbereichExpliziteFreigabeFestlegenAction(request));
    }


    async rolleMitteilungenSpeichern() {
        const request = <KommunikationRolleMitteilungOptionenRequest>{
            darf_senden: this.rolleDarfMitteilungenSenden,
            senden_an_alle: this.rolleMitteilungAnAlle,
            senden_an_eigenen_funktionsbereich: this.rolleMitteilungAnAlleFB,
            senden_an_beliebigen_funktionsbereich: this.rolleMitteilungAlleBeliebigenFB,
            senden_an_funktionsbereich_freigeber: this.rolleMitteilungFreigeberFB,
            rolle_id: this.aktuelleRolle.rolle_id,
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            zeitpunkt_utc: new Date(Date.now())
        };
        this.store.dispatch(new PostRolleMitteilungOptionenFestlegenAction(request));
    }

    RolleDarfMitteilungenSenden($event: CustomEvent) {
        if ($event.detail.checked === false) {
            this.rolleMitteilungAnAlle = false;
            this.rolleMitteilungAnAlleFB = false;
            this.rolleMitteilungAlleBeliebigenFB = false;
            this.rolleMitteilungFreigeberFB = false;
        }
    }

    funktionsbereichAbteilungsLeitstandSpeichern() {
        const request = <IncidentsFunktionsbereichAbteilungRequest>{
            bezeichnung: this.funktionsbereichAbteilungsLeitstandBezeichnung,
            ist_aktiv: this.funktionsbereichAbteilungsLeitstandAktiv,
            rufnummer: this.funktionsbereichAbteilungsLeitstandRufnummer,
            zentrale_darf_delegieren: this.leitzentraleDarfDelegieren,
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            zeitpunkt_utc: new Date(Date.now())
        };
        this.store.dispatch(new PostFunktionsbereichAbteilungSetzenAction(request));
    }

    FunktionsbereichAbteilungsLeitstandAktivSetzen($event: CustomEvent) {
        if ($event.detail.checked === false) {
            this.funktionsbereichAbteilungsLeitstandBezeichnung = null;
            this.funktionsbereichAbteilungsLeitstandRufnummer = null;
        }
    }

    rolleZentralLeitstandSpeichern() {
        const request = <IncidentsRolleOptionenRequest>{
            // ist_aktiv: this.rolleZentralLeitstandAktiv,
            ist_manager: this.rolleZentralLeitstandManager,
            ist_abarbeiter: this.rolleZentralLeitstandAbarbeiter,
            ist_leser: this.rolleZentralLeitstandLeser,
            rolle_id: this.aktuelleRolle.rolle_id,
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            zeitpunkt_utc: new Date(Date.now())
        };
        this.store.dispatch(new PostRolleZentraleSetzenAction(request));
    }

    rolleAbteilungsLeitstandSpeichern() {
        const request = <IncidentsRolleOptionenRequest>{
            // ist_aktiv: this.rolleAbteilungsLeitstandAktiv,
            ist_manager: this.rolleAbteilungsLeitstandManager,
            ist_abarbeiter: this.rolleAbteilungsLeitstandAbarbeiter,
            ist_leser: this.rolleAbteilungsLeitstandLeser,
            rolle_id: this.aktuelleRolle.rolle_id,
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            zeitpunkt_utc: new Date(Date.now())
        };
        this.store.dispatch(new PostRolleAbteilungSetzenAction(request));
    }

    async downloadExcel() {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Exceldownload für Funktionsbereiche wird geladen'
        });
        await loading.present();

        const url = '/api/datentransfer/export/xlsx';
        this.documentService.getDocumentByPost(url, {}).pipe(takeWhile(() => this.alive)).pipe(takeUntil(this.unsubscribe$))
            .subscribe(async (document) => {
                    if (document != null) {
                        console.log('loaded');
                        await loading.dismiss();

                        const date = new Date();
                        const month: number = <number>date.getMonth() + 1;
                        this.documentService.saveFile(document, 'ListeFunktionsbereiche-' + date.getFullYear() + '-' + month + '-' + date.getDate());
                    }
                },
                error => {
                    this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                    loading.dismiss();
                }, () => {
                });
    }

    rolleEinlasskontrolleSpeichern() {
        const request = <EinlasskontrolleRolleOptionenRequest>{
            ist_aktiv: this.rolleEinlasskontrolleAktiv,
            ist_protokollierung_aktiv: this.rolleZertifikatProtokollierungAktiv,
            rolle_id: this.aktuelleRolle.rolle_id,
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            zeitpunkt_utc: new Date(Date.now())
        };
        this.store.dispatch(new PostEinlasskontrolleRolleBerechtigungSetzenAction(request));
    }

    rolleDisplaysteuerungSpeichern() {
        const request = <DisplaysteuerungRolleBerechtigungenRequest>{
            ist_aktiv: this.rolleDisplaysteuerungAktiv,
            darf_verwalten: this.rolleDisplaysteuerungAktiv,
            rolle_id: this.aktuelleRolle.rolle_id,
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            zeitpunkt_utc: new Date(Date.now())
        };
        this.store.dispatch(new PostDisplaysteuerungRolleBerechtigungenSetzenAction(request));
    }

    rolleBerechtigungenSpeichern() {
        const request = <IncidentsRolleBerechtigungenRequest>{
            darf_delegation_bei_anlegen: this.rolleDarfDelegierenBeiNeuanlage,
            darf_verantwortung_bei_anlegen: this.rolleDarfVerantwortlichkeitBeiNeuanlage,
            rolle_id: this.aktuelleRolle.rolle_id,
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            zeitpunkt_utc: new Date(Date.now())
        };
        this.store.dispatch(new PostIncidentsRolleBerechtigungenSetzenAction(request));
    }

    rolleQsChecksSpeichern() {
        const request = <QsChecksRolleBerechtigungenRequest>{
            ist_qs_admin: this.rolleQSAdminAktiv,
            rolle_id: this.aktuelleRolle.rolle_id,
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            zeitpunkt_utc: new Date(Date.now())
        };
        this.store.dispatch(new PostQsChecksRolleBerechtigungenSetzenAction(request));
    }

    rolleVeranstaltungenSpeichern() {
        const request = <VeranstaltungBenutzerverwaltungRolleBerechtigungenRequest>{
            rolle_id: this.aktuelleRolle.rolle_id,
            funktionsbereich_id: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            darf_funkprotokoll: this.rolleFunkprotokollAktiv,
            zeitpunkt_utc: new Date(Date.now())
        };
        this.store.dispatch(new PostVeranstaltungenBenutzerverwaltungRolleBerechtigungenSetzenAction(request));
    }

    rolleMitteilungensVorlageSpeichern() {
        this.store.dispatch(new actionsUi.MitteilungsVorlageSpeichernAction);
    }

    mitteilungsVorlageLaden(item: MitteilungsVorlage) {
        this.store.dispatch(new GetMitteilungsVorlageDetailAction(item.mitteilungs_vorlage_id));
        this.store.dispatch(new actionsUi.AktuelleMitteilungsVorlageSetzenAction(item));
    }

    neueMitteilungsVorlage() {
        this.store.dispatch(new actionsUi.NeueMitteilungsVorlageAction());
    }

    vorlageEntfernen(vorlage: MitteilungsVorlage) {
        if (vorlage !== null) {
            this.store.dispatch(new PostMitteilungsVorlageEntfernenAction({
                mitteilungs_vorlage_id: vorlage.mitteilungs_vorlage_id,
            }));
        }
    }

    vorlageTitelSetzen($event: any) {
        // console.log('Titel : ', $event.target.value);
        this.store.dispatch(new VorlageTitelSetzenAction($event.target.value));
    }

    vorlageBeschreibungSetzen($event: any) {
        // console.log('Beschreibung : ', $event.target.value);
        this.store.dispatch(new VorlageBeschreibungSetzenAction($event.target.value));
    }

    empfaengerGewaehlt($event: Array<string>) {
        // console.log('Empfaenger: ', $event);
        this.store.dispatch(new AktuelleVorlageEmpfaengerSetzenAction($event));
    }

    empfaengerEntfernen(empfaenger: Array<string>, detail: MitteilungsVorlageDetail) {
        // console.log('Empfaenger: ', empfaenger);
        const request: MitteilungsVorlageRolleMultiRequest = {
            mitteilungs_vorlage_id: detail.mitteilungs_vorlage_id,
            rolle_ids: empfaenger
        };
        this.store.dispatch(new PostMitteilungsVorlageEmpfaengerRollenEntfernenAction(request));
    }

    async empfaengerHinzufuegen(detail: MitteilungsVorlageDetail) {
        const rollenIds: Array<string> = [];
        this.vorlagenEmpfaenger.forEach(item => rollenIds.push(item.item.rolle.rolle_id));
        const params = {
            titel: detail.titel,
            nichtAnzuzeigendeRollenIds: rollenIds,
            funktionsbereich: this.aktuellerFunktionsbereichDetail.funktionsbereich_id,
            untertitel: 'Empfänger-Berechtigung für Vorlage',
            alleAnzeigen: true,
            datenquelle: Datenquelle.Vorlagen
        };
        // console.log('Params: ', params);
        const modal = await this.modalCtrl.create({component: RollenselektionPage, componentProps: params});
        modal.onDidDismiss().then((result: any) => {
            if (result != null && result.data) {
                // console.log('REsult: ', result);
                result.data.ausgewaehlteRollen.forEach((x: string) => {
                    const request: MitteilungsVorlageRolleMultiRequest = {
                        mitteilungs_vorlage_id: detail.mitteilungs_vorlage_id,
                        rolle_ids: result.data.ausgewaehlteRollen
                    };
                    this.store.dispatch(new PostMitteilungsVorlageEmpfaengerRollenHinzufuegenAction(request));
                });
            }
        });

        await modal.present();
    }

    typenEntfernen(typen: any, detail: any) {
        const request: MitteilungsVorlageTypMultiRequest = {
            mitteilungs_vorlage_id: detail.mitteilungs_vorlage_id,
            typ_ids: typen
        };
        this.store.dispatch(new PostMitteilungsVorlageVeranstaltungsTypenEntfernenAction(request));
    }

    async typenHinzufuegen(detail: any) {
        const typenIds: Array<string> = [];
        this.vorlagenTypen.forEach(item => typenIds.push(item.item.veranstaltungstyp_id));
        const params = {
            titel: detail.titel,
            nichtAnzuzeigendeTypenIds: typenIds,
            untertitel: 'Typen-Berechtigung für Vorlage',
            datenquelle: DatenquelleVeranstaltungsTypen.Kommunikation,
            enableSingleSelection: false
        };
        // console.log('Params: ', params);
        const modal = await this.modalCtrl.create({component: VeranstaltungstypAuswahlPage, componentProps: params});
        modal.onDidDismiss().then((result: any) => {
            if (result != null && result.data) {
                // console.log('REsult: ', result);
                result.data.ausgewaehlteTypen.forEach((x: string) => {
                    const request: MitteilungsVorlageTypMultiRequest = {
                        mitteilungs_vorlage_id: detail.mitteilungs_vorlage_id,
                        typ_ids: result.data.ausgewaehlteTypen
                    };
                    this.store.dispatch(new PostMitteilungsVorlageVeranstaltungsTypenHinzufuegenAction(request));
                });
            }
        });

        await modal.present();
    }

    typenGewaehlt($event: any) {
        this.store.dispatch(new AktuelleVorlageTypenSetzenAction($event));
    }
}
